import SvgIcon from "@mui/material/SvgIcon";

const LogoIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 90 32" {...props}>
      <path
        d="M45 0c8.831 0 15.99 7.16 15.99 15.99 0 6.422-3.784 11.96-9.244 14.504l-1.25-19.25V4.997L47.5 9.245H42.5l-2.998-4.248v6.247l-1.25 19.25c-5.46-2.545-9.244-8.082-9.244-14.503C29.01 7.159 36.17 0 45 0z"
        clip-rule="evenodd"
        fill-rule="evenodd"
      />
      <path d="M85.32 0l-.04 19.517H90v4.884h-4.72L85.295 32h-5.842v-7.6H64.586v-3.704L79.803 0h5.517zm-5.278 8.046L71.69 19.517h8.352V8.047zM20.733 0l-.04 19.517h4.72v4.884h-4.72L20.71 32h-5.842v-7.6H0v-3.704L15.217 0h5.516zm-5.277 8.046L7.104 19.517h8.352V8.047z" />
    </SvgIcon>
  );
};

export default LogoIcon;
